import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";

export const fetchFilesByEntityId = (entity_id): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_FILES),
    shouldCallAPI: state => !state.modules.files.ids.includes(entity_id),
    callAPI: {
        url: `/api/v2/files/entity/${entity_id}`
    }
});

export const patchFileById = (id, data): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.PATCH_FILE),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/files/${id}`,
        body: data
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
});

export const deleteFileById = (id): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.DELETE_FILE),
    callAPI: {
        method: 'DELETE',
        url: `/api/v2/files/${id}`
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol verwijderd',
        [NOTIFICATIONTYPE.ERROR]: 'Verwijderen mislukt'
    }
});

export const uploadFilesForEntityId = (entity_id, data): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPLOADING_FILES),
    callAPI: {
        method: 'POST',
        url: `/api/v2/files/entity/${entity_id}`,
        formData: data
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol geupload',
        [NOTIFICATIONTYPE.ERROR]: 'Uploaden mislukt'
    }
});